export {
  addForm as addWixForm,
  addFormToContainer as addWixFormToContainer,
} from './categories/contact/wixForms/utils';

export { addAppointment as addAppointmentField } from './categories/developer/appointmentField/utils';

export { default as databaseWelcomePanelView } from './categories/database/databaseWelcome/databaseWelcome';

////////////
import * as addPanelDefinitions from '#packages/addPanelDefinitions';
import {
  applyOverrideForCategories,
  createCategoriesSectionsAccessor,
} from './categories/addData';
import {
  getDesignPanelTitleByComp,
  getSectionsByComponentType,
} from './designData/designData';
import manager from './utils/dataRegistrationManager';

const { getCategories, getCategory } = createCategoriesSectionsAccessor(
  addPanelDefinitions.categoriesDefinition,
);

export {
  getCategories,
  getCategory,
  applyOverrideForCategories,
  getSectionsByComponentType,
  getDesignPanelTitleByComp,
  manager,
};
